import React from 'react';
import FormField from '../../../components/forms/FormField';
import { FiPlus, FiMinus } from 'react-icons/fi';

export default function PoliticasPublicas({ repeatableFields, addRepeatableField, removeRepeatableField }) {
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações sobre programas e políticas públicas voltadas ao desenvolvimento produtivo local.</p>
    </div>

    {/* Campos repetíveis para programas */}
    {repeatableFields.programa.map((item) => (
      <div key={item.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-md font-medium">Programa/Política {item.id}</h3>
          {item.id !== 1 && (
            <button 
              type="button" 
              onClick={() => removeRepeatableField('programa', item.id)}
              className="text-red-500 hover:text-red-700"
            >
              <FiMinus className="mr-1" /> Remover
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            name={`programa_nome_${item.id}`}
            label="Nome do programa"
            placeholder="Digite o nome do programa ou política"
            helpText="Nome oficial do programa ou política pública"
          />
          
          <FormField
            name={`programa_foco_${item.id}`}
            label="Foco"
            placeholder="Digite o foco principal do programa"
            helpText="Área de atuação ou objetivo principal"
          />
        </div>
        
        <div className="mt-4">
          <FormField
            name={`programa_financiamento_${item.id}`}
            label="Fonte de financiamento"
            placeholder="Digite a fonte de financiamento"
            helpText="Ex: recursos municipais, estaduais, federais, parcerias, etc."
          />
        </div>
        
        <div className="mt-4">
          <FormField
            name={`programa_resultados_${item.id}`}
            label="Resultados relatados"
            type="textarea"
            placeholder="Descreva os resultados obtidos até o momento"
            helpText="Resultados quantitativos ou qualitativos observados"
          />
        </div>
      </div>
    ))}
    
    <div className="mb-4">
      <button 
        type="button" 
        onClick={() => addRepeatableField('programa')}
        className="flex items-center text-blue-600 hover:text-blue-800"
      >
        <FiPlus className="mr-1" /> Adicionar outro programa/política
      </button>
    </div>
    
    <div className="mt-6">
      <FormField
        name="presenca_apl"
        label="Presença de Arranjos Produtivos Locais (APLs)"
        type="radio"
        options={[
          { value: 'sim', label: 'Sim' },
          { value: 'nao', label: 'Não' },
        ]}
        helpText="Indique se existem APLs formalmente constituídos no município"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="descricao_apl"
        label="Descrição do APL"
        type="textarea"
        placeholder="Descreva o APL existente"
        helpText="Preencha apenas se respondeu 'Sim' à questão anterior"
      />
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <FormField
        name="nome_programa_iniciativa"
        label="Nome do programa ou iniciativa"
        placeholder="Digite o nome do programa ou iniciativa"
        helpText="Nome de outro programa ou iniciativa relevante"
      />
      
      <FormField
        name="parcerias"
        label="Parcerias"
        placeholder="Digite as parcerias existentes"
        helpText="Instituições parceiras na execução de programas"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="resultados_relatados"
        label="Resultados relatados"
        type="textarea"
        placeholder="Descreva os resultados obtidos"
        helpText="Resultados observados dos programas e iniciativas"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="infraestrutura_apoio"
        label="Infraestrutura de apoio à produção local"
        type="textarea"
        placeholder="Descreva a infraestrutura de apoio existente"
        helpText="Ex: distritos industriais, incubadoras, centros de capacitação, etc."
      />
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao3"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao3"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
